import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, inject } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';
import { CurrencyPipe, NgIf } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { ToastrService } from 'ngx-toastr';
import { MakePaymentComponent } from "../make-payment/make-payment.component";
import { drawCanvas } from '../../../utils/helper.';
import { CategoryStateService } from '../../../services/state-management/category/category-state.service';
import { ROLE } from '../../../models/constant/constants';
import { StorageService } from '../../../services/state-management/storage.service/storage.service';
import { GuestLoginComponent } from '../../../modal/guest-login/guest-login.component';
import { ExploreService } from '../../../services/API/explore.service/exploreservice';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';

@Component({
  selector: 'app-art-detail-card',
  standalone: true,
  imports: [NgIf, CurrencyPipe, ButtonComponent, MakePaymentComponent, GuestLoginComponent, ClickOutsideDirective],
  templateUrl: './art-detail-card.component.html',
  styleUrls: ['./art-detail-card.component.scss'],
  animations: [
    trigger('slideDialog', [
      state(
        'hidden',
        style({
          transform: 'translate(-50%, 100%)',
        })
      ),
      state(
        'visible',
        style({
          transform: 'translate(-50%, -50%)',
        })
      ),
      transition('hidden => visible', [
        animate(
          '500ms ease-out',
          keyframes([
            style({ transform: 'translate(-50%, 100%)', offset: 0 }),
            style({ transform: 'translate(-50%, -55%)', offset: 0.7 }),
            style({ transform: 'translate(-50%, -50%)', offset: 1 }),
          ])
        ),
      ]),
      transition('visible => hidden', [
        animate(
          '300ms ease-in',
          style({
            transform: 'translate(-50%, 100%)',
          })
        ),
      ]),
    ]),
  ],
})
export class ArtDetailCardComponent implements OnInit {
  storageService = inject(StorageService);

  @Input() isVisible = false;
  @Input() disableAllActions = false;
  @Input() isArtistPreview = false;
  @Input() isArtInAlbum = false;
  @Input() card?: {
    id: string | null;
    artistId: number;
    artName: string;
    placeName: string;
    region: string;
    city: string;
    country: string;

    imageUrl: string;
    artThumbnailUploadUrl: string;
    artThumbnailUrl: string;

    likeUnlikeStatus: boolean;
    artistName: string;
    description: string;
    subscribed: boolean;
    price: number,
    artPrice: number,
    watermark: boolean,
    signature: string,
    nameAsSignature: boolean,
  };
  @Output() cardClick = new EventEmitter<string>();
  @Output() likeClick = new EventEmitter<{ id: any; likeUnlikeStatus: boolean, artistId: number }>();
  @Output() close = new EventEmitter<void>();
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  isLoginPopupOpen = false;

  role: ROLE = ROLE.GUEST;
  slideState = 'hidden';
  liked: boolean = false;
  menuOpen: boolean = false; // To toggle the dropdown menu
  @Output() edit = new EventEmitter<void>(); // Emits event for editing
  @Output() delete = new EventEmitter<void>(); // Emits event for deletion
  @Output() album = new EventEmitter<void>(); // Emits event for album
  @Output() openGuestLoginPopup = new EventEmitter<null>();
  artistId: any = 0;
  exploreService = inject(ExploreService);
  constructor(
    private toaster: ToastrService,
    private categoryStateService: CategoryStateService
  ) { }


  requestPrice(): void {
    if (typeof this.card?.id === 'number') {
      this.exploreService.requestPrice(this.card?.id).subscribe(res => {
        this.toaster.success(res.message);
      })
    }
  }

  ngOnInit(): void {
    if (this.card) {
      this.liked = this.card.likeUnlikeStatus;
    }
    this.storageService.getRole().subscribe(role => this.role = role);
    this.artistId = this.storageService.getArtistId() || 0;
    setTimeout(() => (this.slideState = 'visible'), 0);
  }

  toggleMenu(event: Event): void {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }



  editArt(): void {
    this.menuOpen = false; // Close the menu
    this.edit.emit(); // Emit the edit event
  }

  deleteArt(): void {
    this.menuOpen = false; // Close the menu
    this.delete.emit(); // Emit the delete event
  }

  addToAlbum(): void {
    this.menuOpen = false; // Close the menu
    this.album.emit(); // Emit the delete event
  }

  closeModal(): void {
    this.slideState = 'hidden';
    setTimeout(() => this.close.emit(), 300);
  }

  toggleLike(event: Event): void {
    event.stopPropagation();
    if (this.role === ROLE.GUEST) {
      this.isLoginPopupOpen = true;
      return;
    }
    if (!this.card?.id) {
      this.toaster.error('Invalid card data for like action.');
      return;
    }

    this.liked = !this.liked;
    this.likeClick.emit({ id: this.card?.id, likeUnlikeStatus: this.liked, artistId: this.card.artistId });
    this.categoryStateService.updateArtworkLikeState(this.card?.id, this.liked);
  }


  isPayment: boolean = false;
  makePayment() {
    if (this.role === ROLE.GUEST) {
      this.isLoginPopupOpen = true;
      return;
    }
    const price = this.card?.price;
    if (price) {
      this.isPayment = !this.isPayment;
    } else {
      this.toaster.info('Art has no price.')
    }
  }

  ngAfterViewInit(): void {
    drawCanvas(
      this.canvasRef.nativeElement,
      this.card?.imageUrl || this.card?.artThumbnailUploadUrl || this.card?.artThumbnailUrl,
      this.card?.watermark,
      this.card?.nameAsSignature ? null : this.card?.signature,
      this.card?.artistName,
      700,
      300,
      60,
      25,
      12,
      true,
    )
  }
}
